import TableCategory from "./TableCategory";

const TableCategoriesListView = ({list = [], setActiveCategoryId, activeCategoryId}) => {
    const handleCategoryClick = (category) => {
        setActiveCategoryId(category.id);
    };

    return (
        <div className="relative w-[100%] h-auto flex justify-start items-center px-[0.25vw] flex-wrap">
            {list.map((category) => (
                <TableCategory
                    key={category.id}
                    name={category.name}
                    active={category.id === activeCategoryId}
                    onClick={() => handleCategoryClick(category)}
                />
            ))}
        </div>
    );
};

export default TableCategoriesListView;
